import { render, staticRenderFns } from "./VoucherPageHeader.vue?vue&type=template&id=09fd5f6f&scoped=true"
import script from "./VoucherPageHeader.vue?vue&type=script&lang=js"
export * from "./VoucherPageHeader.vue?vue&type=script&lang=js"
import style0 from "./VoucherPageHeader.vue?vue&type=style&index=0&id=09fd5f6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd5f6f",
  null
  
)

export default component.exports